var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullseye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.85 88.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke:#30225f;stroke-width:2.77px;}.cls-2{stroke:#44cff2;stroke-width:2.51px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About_Us_Page",
    "data-name": "About Us Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Our_Mission",
    "data-name": "Our Mission"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bullseye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.48,2.79A43,43,0,1,1,2.66,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.23,16.13a29.19,29.19,0,1,1-22,28.29,28.86,28.86,0,0,1,.86-7.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.44,29.17A15.76,15.76,0,1,1,29.12,40.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.29 20.44 29.98 30.07 20.34 31.38 4.59 15.63 13.75 13.85 15.53 4.68 31.29 20.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.01,
    y1: 30.1,
    x2: 44.75,
    y2: 44.85
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.ae31d0e67739eac246c0ed8b90c322ad.svg";
export { ForwardRef as ReactComponent };